import http from '../../rest/http';


export const fetchDepartmentDetails = async () => {
  try {
    const response = await http.get("/api/v1/department/list-all");
    return response;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
export const fetchGroupDetails = async (departmentId: string) => {
    try {
      const response = await http.get(`/api/v1/department/${departmentId}/get-all-groups`);
      return response;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  };
  export const fetchRoleDetails = async (groupId: string) => {
    try {
      const response = await http.get(`/api/v1/group/${groupId}/roles`);
      return response;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  };
  export const createRole = async (data: any) => {
    try {
      const response = await http.post(`/api/v1/user/assign-base-roles`,data);
      return response;
    } catch (error) {
      console.error('Error in updating users:', error);
      throw error;
    }
  };
  export const fetcTypeAndSpecializationDetails = async (roleId: string) => {
    try {
      const response = await http.get(`/api/v1/role/${roleId}/get-types-specializations`);
      return response;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  };
  export const fetchBranchDetails = async () => {
    try {
      const response = await http.get(`/api/v1/dealer/branch/list-all`);
      return response;
    } catch (error) {
      console.error('Error fetching branch details:', error);
      throw error;
    }
  };
  export const fetchDesignationDetails = async (roleId: string) => {
    try {
      const response = await http.get(`/api/v1/role/${roleId}/get-designations`);
      return response;
    } catch (error) {
      console.error('Error fetching users designation', error);
      throw error;
    }
  };
  
  export const fetchReportingRolesDetails = async (roleID: string) => {
    try {
      const response = await http.get(`/api/v1/role/${roleID}/get-reporting-roles`);
      return response;
    } catch (error) {
      console.error('Error fetching users reporting roles', error);
      throw error;
    }
  };
  export const fetchReportingManagerDetails = async (roleID: string) => {
    try {
      const response = await http.get(`/api/v1/user/get-all-reporting-managers?roleId=${roleID}`);
      return response;
    } catch (error) {
      console.error('Error fetching users reporting manager', error);
      throw error;
    }
  };